import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import { IconButton, Snackbar } from "@mui/material";
import { withStyles } from "@mui/styles";
import clsx from "clsx";
import * as React from "react";

interface ErrorMessageProps {
    message?: string;
    classes: any;
}

interface ErrorMessageState {
    open: boolean;
}

class ErrorMessageWrapped extends React.Component<ErrorMessageProps, ErrorMessageState> {

    constructor(props) {
        super(props);

        this.state = {
            open: true,
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.handleClose();
        }, 5000);
    }

    handleClose = () => this.setState({ open: false });

    render() {
        const { classes } = this.props;

        return (
            <Snackbar
                aria-describedby="client-snackbar"
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={this.state.open}
                onClose={this.handleClose}
                ContentProps={{
                    "aria-describedby": "message-id",
                }}
                action={[
                    <IconButton key="close" aria-label="Close" color="inherit" onClick={this.handleClose}>
                        <CloseIcon className={classes.icon} />
                    </IconButton>,
                ]}
                message={<span id="client-snackbar" className={classes.message}>
                    <ErrorIcon className={clsx(classes.icon, classes.iconVariant)}/>
                    {this.props.message || "Something went wrong!"}
                </span>}
            />
        );
    }
}

const styles: any = theme => ({
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: 8,
    },
    message: {
        display: "flex",
        alignItems: "center",
    },
});

export const ErrorMessage = withStyles(styles)(ErrorMessageWrapped);
